import { Component, OnInit, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { ConfirmationService } from 'primeng/api';

import { TaskEditDialogComponent } from 'src/app/tasks/task-edit-dialog/task-edit-dialog.component';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';

import { TaskSearchDto } from '../../../tasks/shared/dto/task-search.dto';
import { TaskDto } from 'src/app/tasks/shared/dto/task.dto';
import { FeatureNameEnum } from 'src/app/shared/feature/feature-name.enum';
import { SecurityAccessLevelEnum } from 'src/app/shared/auth/enum/security-access-level.enum';

import { DatagridService, PagedResultGeneric, PagedSearch, TranslationService } from 'src/app/shared';
import { ObservationService } from 'src/app/shared/observation/observation.service';
import { TaskService } from 'src/app/tasks/shared/task.service';
import { FeatureService } from 'src/app/shared/feature/feature.service';
import { UserService } from 'src/app/users/shared/user.service';

@Component({
  selector: 'wl-profile-view-tasks',
  templateUrl: './profile-view-tasks.component.html',
  styleUrls: ['./profile-view-tasks.component.less'],
    standalone: false
})
export class ProfileViewTasksComponent extends LazySelectableTableComponent<PagedSearch, TaskDto> implements OnInit, OnChanges {
  @Input() profileId: number;
  @ViewChild(TaskEditDialogComponent) editDialog: TaskEditDialogComponent;

  public tasks = {} as PagedResultGeneric<TaskDto>;
  public rejectText: string;
  public acceptText: string;
  hasProjects = false;
  profileModuleFullAccess: boolean = false;
  profileTasksTabFullAccess: boolean = false;
  loading = false;

  constructor(
    datagridService: DatagridService,
    private _confirmationService: ConfirmationService,
    private _featureService: FeatureService,
    private _observationService: ObservationService,
    private _taskService: TaskService,
    private _translationService: TranslationService,
    private _userService: UserService
  ) {
    super('ProfileTasks', datagridService);
    this.searchParams = new PagedSearch();
    this.searchParams.PageSize = 10;
  }

  ngOnInit(): void {
    this._featureService.has(FeatureNameEnum.Projects).then((data) => {
      this.hasProjects = data;
    });

    this._userService.getCurrentUserSecurityElementAccessLevel('Profiles_Module').then((userAccessLevel: number) => {
      this.profileModuleFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;

      if (this.profileModuleFullAccess) {
        this._userService.getCurrentUserSecurityElementAccessLevel('ProfileTasks_Tab').then((userAccessLevel: number) => {
          this.profileTasksTabFullAccess = userAccessLevel > SecurityAccessLevelEnum.ReadOnlyAccess;
        });
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.profileId) {
      this.search();
    }

    this._observationService.observeProfiles().subscribe((id) => {
      if (id === this.profileId) {
        this.search();
      }
    });
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  fetchResults(): Promise<PagedResultGeneric<TaskDto>> {
    this.loading = true;

    let taskSearchDto = {} as TaskSearchDto;
    taskSearchDto.PageSize = this.searchParams.PageSize;
    taskSearchDto.PageNumber = this.searchParams.PageNumber;
    taskSearchDto.OrderBy = this.searchParams.OrderBy;

    return this._taskService.getProfileTasks(this.profileId, taskSearchDto, false).finally(() => (this.loading = false));
  }

  public deleteTask(id: number) {
    this.rejectText = this._translationService.getInstant('common.cancel').toUpperCase();
    this.acceptText = this._translationService.getInstant('common.delete').toUpperCase();

    this._confirmationService.confirm({
      key: 'deleteTaskCD',
      header: this._translationService.getInstantTitlecase('profiles.view.tasks.delete-this-task'),
      message: this._translationService.getInstantCapitalizeFirstCharacter('profiles.view.tasks.delete-task-body'),
      accept: () => {
        this._taskService.delete(id).then(() => {
          this.search();
        });
      },
      reject: () => {
        this._confirmationService.close();
      },
    });
  }
}
